/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
(function (Drupal, $) {
  'use strict';

  var LARGE_SCREEN_SIZE = 768;

  function isMobile() {    
    return true;
    var width = $(window).width();
    return width < LARGE_SCREEN_SIZE;
  }  

  function openNavigation(toggle, context) {    
    $("#nav-block-hcp-main-menu-menu").show();
    toggle.addClass('is-active');
    // toggle.attr('aria-expanded', "true");    
    var navId = toggle.attr('for');    
    $('#' + navId, context).addClass('is-active');
    $('body', context).addClass('mobile-menu-active');

    var header = $('.header-toolbar', context);
    var headerHeight = header.outerHeight();

    adjustPosition(toggle, context);

    $("#nav-block-hcp-main-menu-menu").focus();
  }

  function adjustPosition(toggle, context) {
    var header = $('.header-toolbar', context);
    var headerHeight = header.outerHeight();

    if ($('.toolbar-vertical').length) {      
      $('.menu--main', context).css('top', headerHeight + 4);
    } else if ($('.toolbar-horizontal').length) {
      $('.menu--main', context).css('top', headerHeight + 56);
    } else {
      $('.menu--main', context).css('top', 70);
    }    

    var width = $(window).width();
    if (width > LARGE_SCREEN_SIZE) {
      var offsetLeft = $(".header-container").offset().left + 28;
      $('.menu--main', context).css("left", offsetLeft);    
      toggle.find(".close").css("left", $(".menu--main", context).width() - 32);
    } else {
      $('.menu--main', context).css("left", 0);    
      $('.menu--main', context).css('top', 88);
    }   
  }

  function closeNavigation(toggle, context) {
    toggle.removeClass('is-active');
    // toggle.attr('aria-expanded', "false");
    var navId = toggle.attr('for');
    $('#' + navId, context).removeClass('is-active');
    $('body', context).removeClass('mobile-menu-active');
    toggle.focus();
    setTimeout(function(){
      $("#nav-block-hcp-main-menu-menu").hide();      
    }, 500);    
  }

  function handleNavigationToggle(context) {            
    $('#nav-toggle', context).off('click').on('click', function(event) {
      if ($(this).hasClass('is-active')) {        
        closeNavigation($(this), context);
      } else {        
        openNavigation($(this), context);
      }
    });

    $('.btn-close', context).on('click', function(event) {
      closeNavigation($('#nav-toggle'), context);
    });    
  }

  function isExpanded(item) {
    return item.hasClass('menu-item--expanded');
  }

  function expandMenuItem(item) {
    item.addClass('menu-item--expanded');
    var innerMenuHeight = item.children('.inner-menu-container').children('.menu').height();
    item.children('.inner-menu-container').css('height', innerMenuHeight);
  }

  function collapseMenuItem(item) {
    item.removeClass('menu-item--expanded');
    item.children('.inner-menu-container').removeAttr('style');
  }

  function toggleMenuItemExpanded(item) {
    if (isExpanded(item)) {
      collapseMenuItem(item);
    } else {
      expandMenuItem(item);
    }
  }

  function handleNavigationInnerExpand(context) {
    $('.menu .menu-item a', context).focus(function() {
      expandMenuItem($(this).parents('li'));
    });
    $('.menu .menu-item a', context).blur(function() {
      collapseMenuItem($(this).parents('li'));
    });

    $('.menu-item--below', context).on('mouseenter mouseleave', function() {
      // If screen size is mobile, do not proceed with hover
      if (isMobile()) {
        return;
      }
      toggleMenuItemExpanded($(this));
    });
    
    $('.menu-item--below a', context).on('mousedown', function(event) {
      // If screen size is desktop, do not proceed
      if (!isMobile()) {
        return;
      }
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
    });

    $('.menu-item--below a, .menu-item--below span', context).on('click', function(event) {
      // If screen size is desktop, do not proceed with on click
      if (!isMobile()) {
        return;
      }

      var hasLink = $(this).is('a');
      var li = $(this).parents('li');
      var expanded = isExpanded(li);

      // If inner menu has already been expanded:
      //   If this item has a link, follow default behavior of click
      //   Otherwise, collapse the inner menu
      // Otherwise, expand the inner menu
      if (expanded) {
        //   If this item has a link, follow default behavior of click
        //   Otherwise, collapse the inner menu
        if (hasLink) {
          return;
        } else {
          collapseMenuItem(li);
        }
      } else {
        event.stopPropagation();
        event.preventDefault();
        if (hasLink) {
          // This will trigger normal expand menu on focus
          $(this).focus();
        } else {
          expandMenuItem(li);
        }
      }
    });
  }

  function handleHideSeparator(context) {
    var baseOffset = $('.menu-item.menu-level-0:first-child', context).offset();
    if (baseOffset) {
      var baseTopOffset = baseOffset.top;
      $('.menu-item.menu-level-0:not(:first-child)', context).each(function() {
        var currTopOffset = $(this).offset().top;
        var hasHideSeparator = $(this).hasClass('menu-item-hide-separator');
        if (currTopOffset !== baseTopOffset) {
          if (!hasHideSeparator) {
            $(this).addClass('menu-item-hide-separator');
          }
          baseTopOffset = currTopOffset;
        } else if (hasHideSeparator) {
          $(this).removeClass('menu-item-hide-separator');
        }
      });
    }
  }

  function handleWindowResize(context) {
    $(window).on('resize', function() {
      adjustPosition($("#nav-toggle"), context);
      handleHideSeparator(context);

     checkZoom();
    });
  }

  function checkZoom() {  
    var browserZoomLevel = Math.round(window.devicePixelRatio * 100);     
    var width = $(window).width();         
    if (browserZoomLevel > 100 && width < LARGE_SCREEN_SIZE && !mobileCheck()) {                       
      $("body").addClass("zoomed");
      $("body").css('margin-top', 0);
    } else {
      $("body").removeClass("zoomed");
    }
  }

  function initNavigation(context) {
    handleHideSeparator(context);
    const parent = document.getElementById('nav-block-hcp-main-menu-menu');

    parent.addEventListener('focusout', e => {      
      var width = $(window).width();
      // if (width > LARGE_SCREEN_SIZE) {
        const leavingParent = !parent.contains(e.relatedTarget);

        if (leavingParent) {
          closeNavigation($("#nav-toggle"), context); 
        }
      // }
    });

    $(".suggested_training__image").click(function() {            
      $(this).next().children("a").first()[0].click();      
    });

    $(".suggested_training__link a").attr("target", "blank");    
    // $("#nav-toggle").attr('aria-expanded', "false");        
    $("body").keydown(function(event) {      
      if (event.keyCode == 27) {
       closeNavigation($("#nav-toggle"), context); 
      }
    });

    $("body").click(function(event) {
      if ($("#nav-toggle").hasClass("is-active")) {
        closeNavigation($("#nav-toggle"), context);
      }
    });
    $("#nav-block-hcp-main-menu-menu").hide();
    $("#nav-block-hcp-main-menu-menu, #nav-toggle").click(function(event) {
      event.stopPropagation();
    });

    checkZoom();
  }    

  function initBreadcrumbs() {
    var referrer = document.referrer;
    if (referrer.includes("postnatal-practice")) {
      $(".breadcrumb a[href='/resource-center']").html("Postnatal Practice");
      $(".breadcrumb a[href='/resource-center']").attr("href", "/postnatal-practice");
    } else if (referrer.includes("intranatal-practice")) {
      $(".breadcrumb a[href='/resource-center']").html("Intrantatal Practice");
      $(".breadcrumb a[href='/resource-center']").attr("href", "/intranatal-practice");
    } else if (referrer.includes("prenatal-practice")) {
      $(".breadcrumb a[href='/resource-center']").html("Pretnatal Practice");
      $(".breadcrumb a[href='/resource-center']").attr("href", "/prenatal-practice");
    }

      var userAgent = navigator.userAgent.toLowerCase();
      var android = userAgent.indexOf("android") > -1;      
      if (android) {
          $("body").addClass("android");
      }
  }

  window.mobileCheck = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

  Drupal.behaviors.handleNavigationToggle = { attach: handleNavigationToggle };
  Drupal.behaviors.handleNavigationInnerExpand = { attach: handleNavigationInnerExpand };
  Drupal.behaviors.handleWindowResize = { attach: handleWindowResize };
  Drupal.behaviors.initNavigation = { attach: initNavigation };
  Drupal.behaviors.initBreadcrumbs = { attach: initBreadcrumbs };

})(Drupal, jQuery);
